<div *ngIf="!isSubAppIframeShowed" class="vtr-header-main">
	<!-- <img class="vtr-header-main-img" #dccHeaderBackground
		[src]="dccService.headerBackground"
		alt="" [hidden] = 'dccHeaderBackground.naturalWidth === 0'> -->
	<div class="vtr-header-main-inner">
		<a class="back" id="" (click)="goBack()" href="javascript:void(0);">
			{{backArrow}}
			<span>{{'common.ui.back' | translate}}</span>
		</a>
		<h1 class="title">{{title}}</h1>
	</div>
</div>
<div *ngIf="!isSubAppIframeShowed && !showSkeleton" class="spinner-content w-100">
	<div class="spinner-border text-primary progress-spinner" role="status"></div>
</div>
<div *ngIf="!isSubAppIframeShowed && showSkeleton" class="vtr-page">
	<div class="row vtr-page-columns" >
		<div class="col-lg-7 col-xl-8 vtr-page-column vtr-page-left-column">
			<div class="vtr-page-column-shift-up">
				<ng-content select="left-content"></ng-content>
			</div>
		</div>
		<div class="col-lg-5 col-xl-4 vtr-page-column vtr-page-right-column">
			<div class="vtr-page-column-shift-up">
				<ng-content select="right-content"></ng-content>
			</div>
		</div>
	</div>
</div>
